// @flow
import CompetitionDetail from 'components/competitions/CompetitionDetail';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/competitions/CompetitionDetail';
import { fetchPageList } from 'actions/pageActions';
import { fetchCompetitionsBySlug } from 'actions/competitionsActions';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    sidebar_content: state.pageListState.sidebar_content,
    status: state.pageListState.status,
    competition: state.competitionsState.competition,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    fetchCompetitionsBySlug: (slug: string) => dispatch(fetchCompetitionsBySlug(slug)),
  })
)(CompetitionDetail);